<nav class="main-header navbar navbar-expand navbar-white navbar-light">
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link" (click)="toggleMenuSidebar.emit()" role="button"><i class="fas fa-bars"></i></a>
    </li>
    <li class="nav-item d-none d-sm-inline-block">
      <a [routerLink]="['/']" class="nav-link">Home</a>
    </li>
  </ul>
  <ul class="navbar-nav ml-auto">
    <h1 [class]="'environment ' + envLabel">
      {{ envLabel + ' Environment' }}
    </h1>
  </ul>
   <button mat-raised-button (click)="logout()" color="warn">Logout</button>
</nav>
